(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-original"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Typewriter Effect for Newsletter Title
  class NewsletterTypewriter {
    constructor(container) {
      this.container = container;
      this.button = container.querySelector('.footer__newsletter-typewriter-button');
      this.animatedSpan = container.querySelector('.footer__newsletter-title-animated');
      this.phrases = [];
      this.currentPhraseIndex = 0;
      this.currentText = '';
      this.isDeleting = false;
      this.isPaused = false;
      this.typingSpeed = 100; // ms per character when typing
      this.deletingSpeed = 50; // ms per character when deleting
      this.pauseAfterType = 2000; // ms to pause after completing a phrase
      this.pauseAfterDelete = 500; // ms to pause after deleting
      
      if (!this.animatedSpan) return;
      
      // Get phrases from data attribute
      const phrasesAttr = this.animatedSpan.getAttribute('data-typewriter-phrases');
      if (phrasesAttr) {
        this.phrases = phrasesAttr.split(',').map(p => p.trim()).filter(p => p);
      }
      
      if (this.phrases.length === 0) {
        // Fallback to default phrase
        this.phrases = ['latest news?'];
        this.animatedSpan.textContent = this.phrases[0];
        return;
      }
      
      // Initialize with first phrase (show immediately, then start typing)
      this.currentText = this.phrases[0];
      this.animatedSpan.textContent = this.currentText;
      this.isPaused = false;
      
      // Start the animation after a brief pause
      setTimeout(() => {
        this.currentText = '';
        this.isDeleting = false;
        this.type();
      }, 1500);
      
      // Button click handler
      if (this.button) {
        this.button.addEventListener('click', () => this.toggle());
      }
      
      // Start typing
      this.type();
    }
    
    toggle() {
      this.isPaused = !this.isPaused;
      if (this.isPaused) {
        this.button.classList.remove('footer__newsletter-typewriter-start');
        this.button.classList.add('footer__newsletter-typewriter-stop');
        this.button.setAttribute('aria-label', 'stop animation');
      } else {
        this.button.classList.remove('footer__newsletter-typewriter-stop');
        this.button.classList.add('footer__newsletter-typewriter-start');
        this.button.setAttribute('aria-label', 'start animation');
        this.type();
      }
    }
    
    type() {
      if (this.isPaused) return;
      
      const currentPhrase = this.phrases[this.currentPhraseIndex];
      
      if (this.isDeleting) {
        // Deleting characters
        this.currentText = currentPhrase.substring(0, this.currentText.length - 1);
        this.animatedSpan.textContent = this.currentText;
        
        if (this.currentText === '') {
          // Finished deleting, move to next phrase
          this.isDeleting = false;
          this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
          setTimeout(() => this.type(), this.pauseAfterDelete);
          return;
        }
        
        setTimeout(() => this.type(), this.deletingSpeed);
      } else {
        // Typing characters
        this.currentText = currentPhrase.substring(0, this.currentText.length + 1);
        this.animatedSpan.textContent = this.currentText;
        
        if (this.currentText === currentPhrase) {
          // Finished typing current phrase, pause then delete
          setTimeout(() => {
            this.isDeleting = true;
            this.type();
          }, this.pauseAfterType);
          return;
        }
        
        setTimeout(() => this.type(), this.typingSpeed);
      }
    }
  }
  
  // Initialize typewriter
  function initTypewriter() {
    const typewriterContainer = document.querySelector('.footer__newsletter-title-wrapper');
    if (typewriterContainer) {
      new NewsletterTypewriter(typewriterContainer);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTypewriter);
  } else {
    initTypewriter();
  }

  // Newsletter: show success message when user lands back after submit (e.g. after challenge page)
  (function() {
    var form = document.getElementById('footer-newsletter-form');
    var successEl = form && form.querySelector('.footer__newsletter-success');
    var fieldsWrap = form && form.querySelector('.footer__newsletter-fields');
    var successMessage = successEl && (successEl.textContent || successEl.innerText || '').trim();

    if (form && successEl) {
      form.addEventListener('submit', function() {
        try { sessionStorage.setItem('footer_newsletter_submitted', '1'); } catch (e) {}
      });

      function checkAndShowSuccess() {
        try {
          if (sessionStorage.getItem('footer_newsletter_submitted') !== '1') return;
          sessionStorage.removeItem('footer_newsletter_submitted');
          if (successMessage) successEl.textContent = successMessage;
          successEl.classList.remove('footer__newsletter-message--hidden');
          if (fieldsWrap) fieldsWrap.classList.add('footer__newsletter-fields--hidden');
          successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) {}
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkAndShowSuccess);
      } else {
        checkAndShowSuccess();
      }
    }
  })();

  // JavaScript: Remove 'open' attribute on mobile only
  // Desktop accordions stay open via HTML 'open' attribute
  function handleMobileAccordions() {
    const footer = document.querySelector('.footer--kiko');
    if (!footer) return;
    
    const isMobile = window.matchMedia('(max-width: 899px)').matches;
    // Get ALL accordion details, not just those with [open]
    const allAccordions = footer.querySelectorAll('.footer__accordion-details');
    
    allAccordions.forEach((details) => {
      // Skip desktop-only accordion inside loyalty (it doesn't show on mobile anyway)
      const accordion = details.closest('.footer__accordion--first');
      if (accordion && accordion.closest('.footer__loyalty--desktop')) return;
      
      if (isMobile) {
        // Mobile: remove 'open' attribute to close accordions
        details.removeAttribute('open');
      } else {
        // Desktop: ensure 'open' attribute is present for all accordions
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
        // Force content visibility on desktop (in case details-disclosure hides it)
        const panel = details.querySelector('.footer__accordion-panel');
        if (panel) {
          panel.style.display = 'block';
          panel.style.height = 'auto';
          panel.style.maxHeight = 'none';
          panel.style.opacity = '1';
          panel.style.visibility = 'visible';
        }
      }
    });
  }
  
  // Run on load - use setTimeout to avoid blocking page load
  setTimeout(handleMobileAccordions, 0);
  
  // Run on resize to handle breakpoint changes
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleMobileAccordions, 150);
  });
  
  // Run when content changes (theme customizer)
  // Only observe accordion sections directly, not the entire footer (better performance)
  if (window.MutationObserver) {
    const footer = document.querySelector('.footer--kiko');
    if (footer) {
      const accordionsWrapper = footer.querySelector('.footer__accordions-wrapper');
      const loyaltyDesktop = footer.querySelector('.footer__loyalty--desktop');
      
      let mutationTimeout;
      const debouncedHandle = () => {
        clearTimeout(mutationTimeout);
        mutationTimeout = setTimeout(handleMobileAccordions, 50);
      };
      
      // Only observe accordion sections, not newsletter (prevents typewriter from triggering)
      if (accordionsWrapper) {
        const observer = new MutationObserver(debouncedHandle);
        observer.observe(accordionsWrapper, { childList: true, subtree: true });
      }
      
      if (loyaltyDesktop) {
        const observer2 = new MutationObserver(debouncedHandle);
        observer2.observe(loyaltyDesktop, { childList: true, subtree: true });
      }
    }
  }
  
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', handleMobileAccordions);
  }

  } catch(e) { console.error(e); }
})();
})();
